/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `alu` - ALU
 * * `briquette` - BRIQUETTE
 * * `alu_loose` - ALU_LOOSE
 * * `pet` - PET
 * * `pet_dummy_bale` - PET Dummy Bale
 * * `pet_dummy_bale_2` - PET Dummy Bale 2
 * * `pet_envases` - PET Envases
 * * `pet_light_blue` - PET Light Blue
 * * `pet_loose` - PET_LOOSE
 * * `hdpe` - HDPE
 * * `hdpe_non_natural` - HDPE Non Natural
 * * `hdpe_colour` - HDPE Colour
 * * `other` - OTHER
 */
export type AIModelChoices = typeof AIModelChoices[keyof typeof AIModelChoices];


export const AIModelChoices = {
  alu: 'alu',
  briquette: 'briquette',
  alu_loose: 'alu_loose',
  pet: 'pet',
  pet_dummy_bale: 'pet_dummy_bale',
  pet_dummy_bale_2: 'pet_dummy_bale_2',
  pet_envases: 'pet_envases',
  pet_light_blue: 'pet_light_blue',
  pet_loose: 'pet_loose',
  hdpe: 'hdpe',
  hdpe_non_natural: 'hdpe_non_natural',
  hdpe_colour: 'hdpe_colour',
  other: 'other',
} as const;
